// client/src/Utilities/timeUtils.js

// ---------------------------------------------------------
// ⏱️ Time Utilities
// ---------------------------------------------------------

/**
 * Normalizes a token expiry value (seconds or milliseconds) to milliseconds (epoch time).
 * * @param {number} exp - The expiry time in seconds or milliseconds.
 * @returns {number} The expiry time in milliseconds (epoch).
 */
export function normalizeExpiry(exp) {
    //If it looks like seconds (e.g., a 10-digit Unix timestamp), convert to milliseconds.
    // We check if it's less than 1 Trillion (1e12), which is roughly the year 2286.
    if (typeof exp === 'number' && exp < 1e12) {
        return exp * 1000;
    }
    // Otherwise, assume it's already in milliseconds.
    return exp;
}